export enum PROJECT_ROLE_NAME {
  PROJECT_VIEWER = 'namespace-viewer',
  PROJECT_MEMBER = 'namespace-member',
  PROJECT_ADMIN = 'namespace-admin',
  PROJECT_METRICS_INTEGRATION_READER = 'namespace-metrics-integration-reader',
}

export const projectRoleFriendlyName: Record<PROJECT_ROLE_NAME, string> = {
  [PROJECT_ROLE_NAME.PROJECT_ADMIN]: 'PROJECT_ADMIN',
  [PROJECT_ROLE_NAME.PROJECT_MEMBER]: 'PROJECT_MEMBER',
  [PROJECT_ROLE_NAME.PROJECT_METRICS_INTEGRATION_READER]: 'METRICS_READER',
  [PROJECT_ROLE_NAME.PROJECT_VIEWER]: 'PROJECT_VIEWER',
} as const;
